<mat-dialog-content style="height: 33vh;">
    <div style="margin-bottom: 2%;">
        <strong >{{titulo}}</strong>
    </div>
    <div [hidden]="nombreTipoTelefono!=''" style="width: 40%;">
        <mat-form-field style="width: 80%; font-size: 2.0vh;">
          <input matInput placeholder="Tipo de teléfono"
              [(ngModel)]=txtTipoTelefono autocomplete="off"
              (keydown.enter)="buscarTipoTelefono()">
        </mat-form-field>
        <i class="fas fa-search" style="font-size: 1.5em; cursor: pointer; color: #4b8cc5;
            margin-top: 0px;" (click)="buscarTipoTelefono()"
            matTooltip="Buscar tipo de teléfono">
        </i>
      </div>
      <div [hidden]="nombreTipoTelefono==''" style="text-align: start; margin-right: 5px;
        margin-top: 30px;">
        <i class="fas fa-trash" style=" margin-right: 5px;
            font-size: 1.5em; cursor: pointer; color: #4b8cc5;
            margin-top: 0px;" (click)="eliminarTipoTelefono()"
            matTooltip="Eliminar tipo de teléfono">
        </i>
        <mat-label>{{nombreTipoTelefono}}</mat-label>
      </div>
    <div style="width: 90%; margin-top: 10px;">
        <mat-form-field style="width: 80%; font-size: 2.0vh;">
            <input matInput placeholder="Teléfono" type="number"
                [(ngModel)]=txtTelefono autocomplete="off">
        </mat-form-field>
    </div>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
        <tr>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
                    <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Cancelar
                </button>
            </td>
            <td style="width: 20%;"></td>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="almacenar()" style="margin-left: 30px;">
                    <i class="fas fa-save fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Almacenar
                </button>
            </td>
        </tr>
    </table>
</div>